import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function ServicesPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const services = [
    {
      title: 'حالة مراجعة – زيارة واحدة',
      price: '460 ريال',
      icon: 'ri-user-follow-line',
      features: [
        'فحص سمع مسحي جديد لتقييم السمع',
        'إعادة ضبط الصوت للسماعة الحالية',
        'ضبط حسب الفحص الجديد',
        'استشارات مجانية',
      ],
      color: 'from-[#184187] to-[#2563a8]',
    },
    {
      title: 'حالة جديدة – زيارتين',
      price: '575 ريال',
      icon: 'ri-user-add-line',
      features: [
        'فحص سمع مسحي جديد',
        'استشارات حول السماعة المناسبة',
        'أخذ طبعة الأذن لتصنيع السماعة',
        'برمجة السماعة الجديدة',
        'إرشادات استخدام والعناية',
      ],
      color: 'from-[#f59e0b] to-[#f97316]',
      featured: true,
    },
  ];

  const additionalServices = [
    {
      icon: 'ri-stethoscope-line',
      title: 'اختبارات السمع',
      description: 'فحوصات شاملة ومتقدمة لقياس السمع باستخدام أحدث الأجهزة والتقنيات',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'برمجة السماعات',
      description: 'برمجة وإعادة برمجة جميع أنواع السماعات الطبية بدقة عالية',
    },
    {
      icon: 'ri-tools-line',
      title: 'الصيانة والإصلاح',
      description: 'خدمات صيانة شاملة وإصلاح السماعات الطبية بكفاءة',
    },
    {
      icon: 'ri-ruler-line',
      title: 'أخذ المقاسات',
      description: 'أخذ مقاسات الأذن بدقة لتصنيع سماعات مخصصة',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'التواصل مع الشركات',
      description: 'نتواصل مع شركات السماعات نيابة عنك لضمان أفضل خدمة',
    },
    {
      icon: 'ri-home-heart-line',
      title: 'زيارات منزلية',
      description: 'نأتي إليك في منزلك أو مكان عملك براحة تامة',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-[#184187] to-[#2563a8]">
        <div className="container mx-auto px-4">
          <div className="text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">خدماتنا</h1>
            <p className="text-xl md:text-2xl max-w-3xl mx-auto leading-relaxed">
              نقدم لك أفضل خدمات السمع والسماعات الطبية في منزلك
            </p>
          </div>
        </div>
      </section>

      {/* Main Services - Pricing */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">باقات الخدمات</h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
              اختر الباقة المناسبة لاحتياجاتك
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {services.map((service, index) => (
              <div
                key={index}
                className={`relative bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-105 ${
                  service.featured ? 'ring-4 ring-[#f59e0b]' : ''
                }`}
              >
                {service.featured && (
                  <div className="absolute top-0 left-0 right-0 bg-gradient-to-r from-[#f59e0b] to-[#f97316] text-white text-center py-2 text-sm font-bold">
                    الأكثر طلباً
                  </div>
                )}
                <div className={`bg-gradient-to-br ${service.color} p-8 text-white ${service.featured ? 'pt-14' : ''}`}>
                  <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                    <i className={`${service.icon} text-5xl`}></i>
                  </div>
                  <h3 className="text-2xl md:text-3xl font-bold text-center mb-4">{service.title}</h3>
                  <div className="text-center">
                    <span className="text-5xl font-bold">{service.price}</span>
                  </div>
                </div>
                <div className="p-8">
                  <ul className="space-y-4">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-2xl text-[#184187] flex-shrink-0"></i>
                        <span className="text-lg text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <button className="w-full mt-8 bg-[#184187] text-white py-4 rounded-lg font-bold text-lg hover:bg-[#0f2d6b] transition-colors whitespace-nowrap cursor-pointer">
                    احجز الآن
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">خدمات إضافية</h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
              مجموعة شاملة من الخدمات المتخصصة
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {additionalServices.map((service, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#184187] to-[#2563a8] rounded-lg flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">{service.title}</h3>
                <p className="text-lg text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-[#184187] to-[#2563a8]">
        <div className="container mx-auto px-4">
          <div className="text-center text-white max-w-4xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">جاهز للبدء؟</h2>
            <p className="text-xl md:text-2xl mb-8 leading-relaxed">
              احجز موعدك الآن واستمتع بخدمة احترافية في منزلك
            </p>
            <button className="bg-white text-[#184187] px-12 py-4 rounded-lg font-bold text-xl hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
              احجز موعدك
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
